/**
 * @generated SignedSource<<fbc0b6a526a8cbc4d1779e144efc40b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftFeaturedCreators_viewer$data = {
  readonly nftFeaturedCreatorsPage: {
    readonly profiles: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NftFeaturedCreatorTile_nftProfile">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "NftFeaturedCreators_viewer";
};
export type NftFeaturedCreators_viewer$key = {
  readonly " $data"?: NftFeaturedCreators_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftFeaturedCreators_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "pageId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftFeaturedCreators_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "pageId"
        }
      ],
      "concreteType": "NftFeaturedCreatorsPage",
      "kind": "LinkedField",
      "name": "nftFeaturedCreatorsPage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftFeaturedCreatorsProfileType",
          "kind": "LinkedField",
          "name": "profiles",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftFeaturedCreatorTile_nftProfile"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1bcfe93ea36975228915f623557f9976";

export default node;
